import type { User } from "types";

export const INVESTOR_DASHBOARD_URL = "https://investor.incomlend.com";
export const INVESTOR_ACCESS_PATH = "/investor-access";

export const isInvestorAccessUser = (user?: Partial<User> | null): boolean => {
  if (!user) return false;

  const rawUser = user as Partial<User> & {
    UserRole?: string | number | null;
    userRole?: string | number | null;
    user_role_id?: string | number | null;
    role_id?: string | number | null;
  };

  const roleValues = [
    rawUser.user_role,
    rawUser.UserRole,
    rawUser.userRole,
    rawUser.user_role_id,
    rawUser.role_id,
  ];

  return roleValues.some((value) => {
    if (value === null || value === undefined) return false;
    const normalized = String(value).trim().toLowerCase();
    return normalized === "4" || normalized === "investor";
  });
};
